import { styled } from "@vitality-ds/system";
import BaseSpinnerStyles from "./styles/BaseSpinner.styles";
import BaseSpinnerCircleStyles from "./styles/BaseSpinnerCircle.styles";
import BaseSpinnerSvgStyles from "./styles/BaseSpinnerSvg.styles";
// eslint-disable-next-line import/prefer-default-export
export var BaseSpinner = styled("span", BaseSpinnerStyles);
export var BaseSpinnerSvg = styled("svg", BaseSpinnerSvgStyles);
export var BaseSpinnerCircle = styled("circle", BaseSpinnerCircleStyles);